/**
 * CuidaDF - Botao de instalacao do PWA
 */

import React, { useEffect, useState } from "react";
import "../styles/InstallButton.css";

function detectarIOS() {
  const ua = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isIPadOS = ua.includes("Macintosh") && navigator.maxTouchPoints > 1;
  return isIOS || isIPadOS;
}

function detectarStandalone() {
  const isStandaloneDisplay = window.matchMedia("(display-mode: standalone)").matches;
  const isIOSStandalone = window.navigator.standalone === true;
  return isStandaloneDisplay || isIOSStandalone;
}

function InstallButton() {
  const [promptEvento, setPromptEvento] = useState(null);
  const [mostrarModalIOS, setMostrarModalIOS] = useState(false);
  const [jaInstalado, setJaInstalado] = useState(false);
  const [ehIOS, setEhIOS] = useState(false);

  useEffect(() => {
    setJaInstalado(detectarStandalone());
    setEhIOS(detectarIOS());

    function aoTerEventoDeInstalacao(evento) {
      evento.preventDefault();
      setPromptEvento(evento);
    }

    function aoInstalar() {
      setJaInstalado(true);
      setPromptEvento(null);
    }

    window.addEventListener("beforeinstallprompt", aoTerEventoDeInstalacao);
    window.addEventListener("appinstalled", aoInstalar);

    return () => {
      window.removeEventListener("beforeinstallprompt", aoTerEventoDeInstalacao);
      window.removeEventListener("appinstalled", aoInstalar);
    };
  }, []);

  async function aoClicarInstalar() {
    if (ehIOS) {
      setMostrarModalIOS(true);
      return;
    }

    if (promptEvento) {
      promptEvento.prompt();
      const resultado = await promptEvento.userChoice;
      if (resultado.outcome === "accepted") {
        setJaInstalado(true);
      }
      setPromptEvento(null);
      return;
    }

    setMostrarModalIOS(true);
  }

  if (jaInstalado) return null;

  const podeMostrarBotao = ehIOS || promptEvento !== null;
  if (!podeMostrarBotao) return null;

  return (
    <>
      <button className="btn-instalar" onClick={aoClicarInstalar}>
        Instalar CuidaDF →
      </button>

      {mostrarModalIOS && (
        <div className="modal-overlay" onClick={() => setMostrarModalIOS(false)}>
          <div className="modal-instalar-ios" onClick={(e) => e.stopPropagation()}>
            <button className="modal-fechar" onClick={() => setMostrarModalIOS(false)}>
              ✕
            </button>
            <h3>Instalar o CuidaDF</h3>
            <p className="modal-subtitulo">
              Adicione o CuidaDF à tela inicial para acessar como um aplicativo.
            </p>

            <div className="modal-passo">
              <span className="modal-passo-numero">1</span>
              <p>Toque em <strong>Compartilhar</strong> ⬆️ na barra do Safari.</p>
            </div>

            <div className="modal-passo">
              <span className="modal-passo-numero">2</span>
              <p>Toque em <strong>"Adicionar à Tela de Início"</strong>.</p>
            </div>

            <div className="modal-passo">
              <span className="modal-passo-numero">3</span>
              <p>Toque em <strong>"Adicionar"</strong> no canto superior direito.</p>
            </div>

            <button className="modal-entendi" onClick={() => setMostrarModalIOS(false)}>
              Entendi
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default InstallButton;
